
import { useState, useEffect } from "react";
import { Requirement } from "@/types/project";
import { RequirementDocument } from "@/types/document";
import { useDocumentService } from "./useDocumentService";

export function useDocuments(requirement: Requirement, projectId: string) {
  const [documents, setDocuments] = useState<RequirementDocument[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const documentService = useDocumentService();

  const refresh = () => setRefreshTrigger(prev => prev + 1);

  useEffect(() => {
    if (projectId && requirement) {
      fetchDocuments();
    } else {
      console.log("Missing projectId or requirement - cannot fetch documents");
      setIsLoading(false);
    }
  }, [projectId, requirement, refreshTrigger]);

  const fetchDocuments = async () => {
    try {
      setIsLoading(true);
      
      // Use requirement.requirement_id if available, otherwise use requirement.id
      const requirementIdToUse = requirement.requirement_id || requirement.id;
      
      if (!requirementIdToUse) {
        console.log("No requirement ID found, cannot fetch documents");
        setDocuments([]);
        return;
      }
      
      const docs = await documentService.fetchDocumentsForRequirement(
        requirementIdToUse,
        projectId
      );
      
      setDocuments(docs);
    } catch (error: any) {
      console.error("Error in useDocuments:", error);
      setDocuments([]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    documents,
    isLoading,
    refresh,
    deleteDocument: documentService.deleteDocument,
    downloadDocument: documentService.downloadDocument
  };
}
